var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourseStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "course-status"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29835",
    "data-name": "Rectangle 29835",
    width: 17,
    height: 12,
    transform: "translate(12 273)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_810",
    "data-name": "Mask Group 810",
    transform: "translate(-12 -273)",
    clipPath: "url(#course-status)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-9_5_",
    "data-name": "svgexport-9 (5)",
    transform: "translate(16.6 272.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15687",
    "data-name": "Group 15687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27120",
    "data-name": "Path 27120",
    d: "M1.247,11.6h.706c.466,0,.847-.54.847-1.2V6.84c0-.664-.381-1.2-.847-1.2H1.247C.781,5.64.4,6.176.4,6.84V10.4C.4,11.06.781,11.6,1.247,11.6Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27121",
    "data-name": "Path 27121",
    d: "M6.253,3.42H5.547c-.466,0-.847.54-.847,1.2V10.4c0,.66.381,1.2.847,1.2h.706c.466,0,.847-.54.847-1.2V4.62c0-.66-.381-1.2-.847-1.2Z",
    transform: "translate(-0.299)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27122",
    "data-name": "Path 27122",
    d: "M10.553,1.2H9.847C9.381,1.2,9,1.74,9,2.4v8c0,.66.381,1.2.847,1.2h.706c.466,0,.847-.54.847-1.2v-8C11.4,1.74,11.019,1.2,10.553,1.2Z",
    transform: "translate(-0.6)",
    fill: "#d5d0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27123",
    "data-name": "Path 27123",
    d: "M1.247,9.73h.706A.838.838,0,0,0,2.8,8.906V6.463a.836.836,0,0,0-.847-.823H1.247A.836.836,0,0,0,.4,6.463V8.906A.838.838,0,0,0,1.247,9.73Z",
    transform: "translate(-4 1.87)",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseStatus);
export default __webpack_public_path__ + "static/media/course-status.e968cecd71522f6b08b375a261f7c300.svg";
export { ForwardRef as ReactComponent };